import { render, staticRenderFns } from "./GeneralOptions.vue?vue&type=template&id=4ba55cc4&scoped=true&"
import script from "./GeneralOptions.vue?vue&type=script&lang=js&"
export * from "./GeneralOptions.vue?vue&type=script&lang=js&"
import style0 from "./GeneralOptions.vue?vue&type=style&index=0&id=4ba55cc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba55cc4",
  null
  
)

export default component.exports